import React, { useEffect, useState } from 'react';
import HeroScreen from '../../../Views/HeroScreen';
import AnimeCard from './AnimeCard';
import SEOHead from '../../SEO/SEOHead';
import './AnimeStyle.css';

const MostFavorited = () => {
    const [animeList, setAnimeList] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchMostFavorited = async () => {
            try {
                await new Promise(r => setTimeout(r, 1500));
                const res1 = await fetch('https://api.jikan.moe/v4/top/anime?filter=favorite&page=1&limit=25');
                const data1 = await res1.json();
                const page1 = data1.data || [];
                setAnimeList(page1);
                setLoading(false);

                await new Promise(r => setTimeout(r, 1200));
                const res2 = await fetch('https://api.jikan.moe/v4/top/anime?filter=favorite&page=2&limit=25');
                const data2 = await res2.json();
                setAnimeList([...page1, ...(data2.data || [])]);
            } catch (error) {
                console.error('Error fetching most favorited anime:', error.message);
            } finally {
                setLoading(false);
            }
        };
        fetchMostFavorited();
    }, []);

    return (
        <div className="anime-page-most-favorited">
            <SEOHead title="ChibiDash | Most Favorited Anime" description="Explore the most favorited anime series. See community favorites on ChibiDash Anime Hub." path="/animehub/most-favorited" />
            <HeroScreen apiUrl="https://api.jikan.moe/v4/top/anime?filter=favorite" />
            <h2 className="small-cards-title">Most Favorited</h2>
            <p className="results-count">{animeList.length} anime found</p>
            {loading ? (
                <div className="loading-spinner-container">
                    <div className="loading-spinner"></div>
                    <p className="loading-text">Loading Favorited Anime...</p>
                </div>
            ) : animeList.length > 0 ? (
                <div className="small-anime-grid">
                    {animeList.map((anime) => (
                        <AnimeCard key={anime.mal_id} anime={anime} />
                    ))}
                </div>
            ) : (
                <p className="empty-text">No favorited anime found.</p>
            )}
        </div>
    );
};

export default MostFavorited;
